/**
 * Created by gocey on 28.08.17.
 */

Box.Application.addModule('sv-home', function (context) {

    var _self = context;

    // retrieve a reference to jQuery
    var $ = context.getGlobal('jQuery');

    var _prepareslider = function () {
        _self.$element = $(context.getElement());
        _self.$sliderItem = _self.$element.find('.sv-slider-item');
        _self.$sliderItemText = _self.$sliderItem.find('.sv-slider-item-text');
        _self.$sliderDots = _self.$element.find('#fp-nav');
    };


    var _initslider = function () {
        _self.$element.fullpage({

            // selectors
            sectionSelector: '.sv-slider-item',

            // navigation
            navigation: true,
            navigationPosition: 'none',

            //Scrolling
            css3: false,
            easing: 'easeInOutCubic',
            scrollOverflow: true,
            scrollOverflowOptions: {
                scrollbars: true,
                mouseWheel: true,
                interactiveScrollbars: true,
                shrinkScrollbars: 'scale',
                fadeScrollbars: true
            },

            afterLoad: function (anchorLink, index) {

                var totalSlide = _self.$sliderItem.length;

                if (totalSlide == index) {
                    $('body').addClass('news');
                    $('#fp-nav').addClass('is-hidden-animate').removeClass('is-visible-animate');
                    $('.scrollBtn').addClass('is-hidden-animate').removeClass('is-visible-animate');
                }

                $('li:last-child a').on('click', function () {
                    $('#fp-nav').addClass('is-hidden-animate').removeClass('is-visible-animate');
                    $('.scrollBtn').addClass('is-hidden-animate').removeClass('is-visible-animate');
                });


                var loadedSection = $(this);
                loadedSection.find('figure').addClass('image-overlay');
                loadedSection.find('.sv-slider-item-text').addClass('is-visible-animate-2x');

            },

            onLeave: function (index, nextIndex, direction) {
                // clearInterval(idInterval);
                var totalSlide = _self.$sliderItem.length;
                var loadedSection = $(this);
                loadedSection.find('figure').removeClass('image-overlay');
                loadedSection.find('.sv-slider-item-text').removeClass('is-visible-animate-2x');

                if (index == totalSlide && direction == 'up') {
                    $('body').removeClass('news');
                    $('#fp-nav').removeClass('is-hidden-animate').addClass('is-visible-animate');
                    $('.scrollBtn').removeClass('is-hidden-animate').addClass('is-visible-animate');
                }else if (index == totalSlide-1 && direction == 'down'){
                    $('body').addClass('news');
                    $('.scrollBtn').addClass('is-hidden-animate').removeClass('is-visible-animate');
                }

            }

        });

        _onClick();
    };

    var _onClick = function () {

        $('.sv-slider-item-text__link').on('click', function (event) {

            event.preventDefault();
            var detailLink = "/" + $(this).attr('href').substring(1);

            $(this).parent().parent().addClass('sv-clicked');
            $('#fp-nav').addClass('is-hidden');
            $('.sv-header-wrapper').removeClass('is-home');
            $('.scrollBtn').addClass('is-hidden-animate').removeClass('is-visible-animate');

            $.fn.fullpage.setKeyboardScrolling(false);
            $.fn.fullpage.setAllowScrolling(false);

            setTimeout(function () {
                // window.location = detailLink;

                $.get(detailLink, function (response, status, xhr) {
                    var bodyClass = response.match(/<body class="(.*)"/);
                    var bodyStyle = response.match(/<body style="(.*)"/);
                    var $body = $('body')
                    var $response = $($.parseHTML(response));
                    var $app = $response.filter('#app');
                    $app.find('#sv-preloader').remove();
                    TweenMax.set($app, {opacity: 0});

                    var $hero = $body.find('.sv-clicked .sv-slider-item-image').clone();
                    $hero.addClass('hero-to-detail-transition-image');
                    $body.append($hero);

                    $hero.imagesLoaded({background: 'picture'})
                        .always(function (instance) {
                            TweenMax.to($hero, 0.2, {
                                opacity: 1, onComplete: function () {
                                    $.fn.fullpage.destroy('all');
                                    Box.Application.stopAll(document.getElementById('app'));
                                    $('#app').remove();

                                    if (bodyClass && bodyClass[1]) {
                                        $body.attr('class', bodyClass[1])
                                    }
                                    if (bodyStyle && bodyStyle[1]) {
                                        $body.attr('style', bodyStyle[1])
                                    }
                                    $body.prepend($app);

                                    window.bus.$once('vuejs-mounted',function(){

                                        history.pushState({}, "Scholz & Volkmer", detailLink);

                                        $app = $('#app');

                                        $('.hero-with-image').imagesLoaded({background: '.image'})
                                            .always(function (instance) {
                                                TweenMax.to($app, 0.3, {opacity: 1});
                                                TweenMax.to($hero, 0.5, {
                                                    opacity: 0, delay: 0.2, onComplete: function () {
                                                        $hero.remove();
                                                        $(document).find('html').attr('style', 'overflow-y: scroll');
                                                        // window.bus.$emit('reinit-vuejs-app')
                                                        Box.Application.startAll(document.getElementById('app'))
                                                    }
                                                });
                                            })
                                    });

                                    window.bus.$emit('reinit-vuejs-app');


                                }
                            });
                        });
                });

            }, 200);
        });

    };

    var _scrollButton = function () {

        $('.scrollBtn').on('click', function () {
            $.fn.fullpage.moveSectionDown();
        });

    };

    var _calcPos = function () {

        var location = $("#sv-logo").offset();

        $("#fp-nav").css({
            'left': location.left + 'px'
        });

    };

    var _initHistoryHandling = function () {
        $(window).on('popstate', function (event) {
            window.location.reload();
        });
    }

    return {

        init: function () {
            _prepareslider();
            _initslider();
            _calcPos();
            _scrollButton();
            _initHistoryHandling();
            $(window).on('load', _calcPos);
            $(window).resize(_calcPos);
            $.fn.fullpage.reBuild();
        }

    };
});



// WEBPACK FOOTER //
// ./sv_cms/static/assets/js/modules/sv-home.js